<h4 class="tig-title">{{OBJ_helper_service.getLabelName(OBJ_field_config)|translate}}</h4>
<tig-dynamic-form *ngIf="OBJ_field_config.fields"
                  [ARR_form_fields]="OBJ_field_config.fields"
                  [OBJ_parent_group]="OBJ_parent_form_group"
                  [STR_form_group_name]="STR_form_group_name"
>
</tig-dynamic-form>